// Translation strings for the public client-facing surfaces.
// The admin app remains in English; only the public quote page reads from here.

export const I18N = {
  en: {
    brand_tag: "Book Quote",
    your_quote: "Your Quote",
    issued: "Issued",
    project: "Project",
    untitled_project: "Untitled project",
    prepared_for: "Prepared for",
    total: "Total",
    per_book: "per book",
    copies: "copies",
    all_prices_in: "All prices in",
    valid_30_days: "Valid 30 days",
    specifications: "Specifications",
    trim_size: "Trim size",
    page_count: "Page count",
    pp: "pp",
    interior_color: "Interior color",
    interior_paper: "Interior paper",
    cover: "Cover",
    binding: "Binding",
    finishing: "Finishing",
    quantity: "Quantity",
    qty_copies: (n) => `${n} copies`,
    ready_to_proceed: "Ready to proceed?",
    ready_subtitle:
      "Confirm to lock in this quote, or decline if it's not the right fit.",
    accept_quote: "Accept Quote",
    decline: "Decline",
    quote_accepted: "Quote accepted.",
    quote_declined: "Quote declined.",
    accepted_msg:
      "Thank you — we'll be in touch shortly to confirm production.",
    declined_msg: "Your response has been recorded.",
    save_pdf: "Save PDF",
    quote_not_found: "Quote not found",
    quote_not_found_sub:
      "This link may have expired or been replaced. Please ask for a new one.",
    loading: "Loading quote…",
    includes_tax: (rate, amount) => `Includes ${rate}% tax (${amount})`,
    quote_footer: (qn) => `Quote ${qn} · 2RA-press Book Quote Studio`,
    status: {
      draft: "Draft",
      sent: "Sent",
      accepted: "Accepted",
      declined: "Declined",
    },
  },
  fr: {
    brand_tag: "Devis de livre",
    your_quote: "Votre devis",
    issued: "Émis le",
    project: "Projet",
    untitled_project: "Projet sans titre",
    prepared_for: "Préparé pour",
    total: "Total",
    per_book: "par livre",
    copies: "exemplaires",
    all_prices_in: "Tous les prix en",
    valid_30_days: "Valide 30 jours",
    specifications: "Spécifications",
    trim_size: "Format",
    page_count: "Nombre de pages",
    pp: "pp",
    interior_color: "Couleur intérieure",
    interior_paper: "Papier intérieur",
    cover: "Couverture",
    binding: "Reliure",
    finishing: "Finition",
    quantity: "Quantité",
    qty_copies: (n) => `${n} exemplaires`,
    ready_to_proceed: "Prêt à valider ?",
    ready_subtitle:
      "Confirmez pour valider ce devis, ou refusez si ce n'est pas adapté.",
    accept_quote: "Accepter le devis",
    decline: "Refuser",
    quote_accepted: "Devis accepté.",
    quote_declined: "Devis refusé.",
    accepted_msg:
      "Merci — nous vous contacterons sous peu pour confirmer la production.",
    declined_msg: "Votre réponse a bien été enregistrée.",
    save_pdf: "Enregistrer PDF",
    quote_not_found: "Devis introuvable",
    quote_not_found_sub:
      "Ce lien a peut-être expiré ou a été remplacé. Veuillez en demander un nouveau.",
    loading: "Chargement du devis…",
    includes_tax: (rate, amount) => `Inclut ${rate} % de TVA (${amount})`,
    quote_footer: (qn) => `Devis ${qn} · 2RA-press Studio Devis Livres`,
    status: {
      draft: "Brouillon",
      sent: "Envoyé",
      accepted: "Accepté",
      declined: "Refusé",
    },
  },
};

export const langs = ["en", "fr"];

export const getT = (lang) => I18N[langs.includes(lang) ? lang : "en"];
